import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { TranslocoService } from '@ngneat/transloco';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-worker-spot',
  templateUrl: './worker-spot.component.html',
  styleUrls: ['./worker-spot.component.scss']
})
export class WorkerSpotComponent implements OnInit {

  @Input() worker:any;

  formGroup = new FormGroup({
    spot: new FormControl('',[])
  });

  submitted = false;

  @Output() refreshWorker = new EventEmitter();

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {

    //console.log('worker',this.worker);

    this.setForm();

  }

  setForm(){
    this.formGroup.setValue({
      spot: this.worker.spot
    });
    //console.log(this.formGroup.value);
  }

  submitForm(){
    this.submitted = true;

    if(this.formGroup.valid){
      let values = this.formGroup.value;
      //console.log('values',values);
      this.okService.put("workers/"+this.worker.id,values)
      .subscribe((data) => {

        this.worker = data.body;
        this.setForm();
        this.refreshWorker.emit();

        this.okService.setAlert(this.transloco.translate("Your SPOT device has been updated"),"success");


      });

    }

    return false;
  }

}
